import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import ThemeToggle from '@/components/Helper/ThemeToggle';
import { useMounted } from '@/hooks/mounted.hook';
import AuthBackground from '@/pages/Auth/Auth-background';

export default function AuthLayout() {
  const mounted = useMounted();

  if (!mounted) {
    return null;
  }

  return (
    <div className="min-h-screen w-full flex overflow-hidden">
      {/* Left Segment */}
      <div className="hidden lg:block lg:w-1/2 bg-left-login items-center justify-center relative">
        {/* Placeholder for future content */}
        <AuthBackground />
      </div>

      {/* Right Segment */}
      <div className="w-full lg:w-1/2 bg-right-login flex flex-col relative">
        {/* Theme Toggle in Top Right */}
        <div className="absolute top-8 right-8 z-50">
          <ThemeToggle />
        </div>

        <main className="flex-1 flex items-center justify-center p-8">
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
